// @ts-check
import adyenGooglePayStrategy from '../../methods/googlepay/strategies/AdyenGooglePayStrategy';
import stripeGooglePayStrategy from '../../methods/googlepay/strategies/StripeGooglePayStrategy';
import googlePayMethod from '../../methods/googlepay/GooglePay';

const engines = {
  adyen: adyenGooglePayStrategy,
  stripe: stripeGooglePayStrategy,
};

/**
 * Factory function for creating Google Pay instances.
 */
function GooglePayFactory() {
  let strategy;

  /**
   * Creates an instance of Google Pay payment with the given engine.
   */
  function create({ engine }) {
    strategy = engines[engine];

    if (!strategy) {
      throw new Error(`Google Pay engine '${engine}' not found`);
    }

    googlePayMethod.setStrategy(strategy);
    return googlePayMethod;
  }

  return { create };
}

const googlePayFactory = GooglePayFactory();

export default googlePayFactory;
